import React from 'react'
import DocumentTitle from 'react-document-title'
import UsersList from 'components/UsersList/UsersList'

const UsersListPage = () => {
  return (
    <section className='container-fluid pt8'>
      <DocumentTitle title='Users List'>
        <section className='flex flex-column pa6 users-list'>
          <h2>Users List</h2>
          <UsersList />
        </section>
      </DocumentTitle>
    </section>
  )
}

export default UsersListPage
